<template>
    <drawer-layout>
        <div class="report-container mx-7 mt-4">
            <indicators-header :type="type"/>

            <indicators-wizard :type="type"/>
        </div>
    </drawer-layout>
</template>

<script>
import DrawerLayout from "@/Shared/DrawerLayout";
import IndicatorsHeader from "@/Shared/Indicators/Wizard/IndicatorsHeader";
import IndicatorsWizard from "@/Shared/Indicators/Wizard/IndicatorsWizard";

export default {
    name: "Generate",
    components: {DrawerLayout, IndicatorsHeader, IndicatorsWizard},

    props: {
        type: {
            type: Object,
            default: [],
        },
    },
}
</script>

<style scoped>

</style>
